import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import ErrorPage from '../../pages/error-page';

interface IProps {
  children: React.ReactNode;
}

export const CustomErrorBoundary = ({ children }: IProps) => {
  const renderFallback = () => {
    return <ErrorPage />;
  };

  const handleOnError = () => {};

  /* test error page */

  // return <ErrorBoundary fallbackRender={renderFallback} onError={handleOnError}>{
  //   <ErrorPage />
  // }</ErrorBoundary>

  return (
    <ErrorBoundary fallbackRender={renderFallback} onError={handleOnError}>
      {children}
    </ErrorBoundary>
  );
};
